import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { emailRegexp } from '@app/shared/util';
import { BankidType } from '@app/authentication/shared/components/bankid-button/bankid-button.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent {
  @Input() waiting!: boolean;
  @Output() loginEmitter = new EventEmitter<{ email: string; password: string }>();
  @Output() trezorLoginEmitter = new EventEmitter<void>();
  formGroup: UntypedFormGroup;
  bankIdTypeEnum = BankidType;

  constructor(private formBuilder: UntypedFormBuilder) {
    this.formGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailRegexp)]],
      password: ['', [Validators.required]],
    });
    this.trezorLogin = this.trezorLogin.bind(this);
  }

  login(): void {
    this.loginEmitter.emit({
      email: this.formGroup.get('email')?.value,
      password: this.formGroup.get('password')?.value,
    });
  }

  trezorLogin() {
    this.trezorLoginEmitter.emit();
  }
}
